import urlJoin from 'url-join'

import { getRedirect } from '@aletheia/common/components/Redirect'

const { Redirect, getServerSideProps } = getRedirect(
  urlJoin(`/stats`, '/overview'),
  true,
)

export { getServerSideProps }

export default Redirect
